import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';
import * as _ from 'lodash';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McWhProductService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  async loadProducts(organization: string) {
    const query: any = {
      $or: [
        { branches: organization }, { warehouse: organization }
      ]
    };

    const res = await this.sdk.warehouse.products().find(query);
    let items: any[] = res.items;
    items = items.map(item => {
      item = this.createProductId(item);
      return item;
    });

    return items;
  }

  removeProduct(id: string) {
    return this.sdk.warehouse.products().remove(id);
  }

    /**
   * Create a temporary id
   * @param order 
   */
  private createProductId(order: any) {
    if (order && order.id) {
      const prefix = order.id.substr(0, 3).toUpperCase();
      const suffix = order.id.substr(-10).toUpperCase();
      const _id = `${prefix}-${suffix}`;
      return { _id, ...order };
    }

    return order;
  }
}
